export default __webpack_public_path__ + "static/media/TodaysRitual_empty.fbc617cd.webp";